export interface ToastEventModel {
  eventTarget: string;
  eventName: string;
  eventPayload: string;
}
